import { Injectable } from "@angular/core";
import { ScorLoadingService, ScorViewerComponent } from "@jack-sparrow-libraries/upload-scor";
import { take } from "rxjs/operators";
import { UiKitToasterService } from "@jack-sparrow-libraries/ui-kit";
import { MatDialog } from "@angular/material/dialog";
import {
	CategorieDocument,
	Document,
	MobileDocument,
	ScorOption,
	TypeTechnique,
} from "@jack-sparrow-libraries/emotion-models";
import { v4 as uuidv4 } from "uuid";
import { AppState, CreateScorFromArray, ResetScorSize, SetCurrentScorSelect } from "features";
import { Store } from "@ngrx/store";
import { LoadingAyWebService } from "@services/loading-ay-web.service";

@Injectable({
	providedIn: "root",
})
export class OrdonnanceScorService implements ScorLoadingService {
	constructor(
		private toastrAyService: UiKitToasterService,
		private dialogService: MatDialog,
		private store: Store<AppState>,
		private loadingService: LoadingAyWebService,
	) {}

	showLoader(): void {
		this.loadingService.showSimpleLoading("", "Numérisation de document en cours");
	}
	hideLoader(): void {
		this.loadingService.hide();
	}

	async openCropper(documents: MobileDocument[]): Promise<Document[]> {
		const invalid = this.checkIfInvalidBlobDocument(documents);
		if (invalid) return;
		const dialogRef = this.dialogService.open(ScorViewerComponent, {
			disableClose: true,
			data: {
				documents: documents,
				index: 0,
				canDelete: false,
			},
		});
		const result = await dialogRef.afterClosed().pipe(take(1)).toPromise();
		if (result?.length > 0) {
			const updatedDocs = result.map((document, index) => {
				return { ...documents[index], documentLob: document.image };
			});
			return this.onValidateListDocs(updatedDocs);
		}
		return null;
	}

	onValidateListDocs(documents = []): Document[] {
		const docs = documents.map((doc) => {
			return {
				...doc,
				id: null,
				uuid: uuidv4(),
				typeTechnique: TypeTechnique.JPEG,
				categorie: CategorieDocument.ORDONNANCE_SCOR,
			} as Document;
		});
		return docs;
	}

	checkIfInvalidBlobDocument(documents: MobileDocument[]) {
		let invalidBlob = false;
		documents.forEach((doc) => {
			if (!doc.documentLob) invalidBlob = true;
		});
		if (invalidBlob) {
			this.toastrAyService.show({ color: "alert", titre: "le document SCOR n'est plus disponible" });
		}
		return invalidBlob;
	}

	mapMobileDocumentForPreview(mobileDoc: MobileDocument) {
		const document: Document = {
			id: mobileDoc.id,
			categorie: CategorieDocument.PATIENT,
			titre: mobileDoc.titre,
			documentLob: mobileDoc.documentLob,
			documentLink: mobileDoc.documentLink,
			typeTechnique: TypeTechnique.JPEG,
			uuid: mobileDoc.uuid ?? uuidv4(),
			documentOrdonnanceId: mobileDoc?.documentOrdonnanceId,
		};
		return document;
	}

	setOrdoDocsForEdit(documents: Document[], scorSelect?: ScorOption) {
		// TODO test if isTeletransmise  => we cannot edit scor then
		this.store.dispatch(new ResetScorSize());
		this.store.dispatch(new SetCurrentScorSelect(scorSelect ?? ScorOption.numerisation));
		this.store.dispatch(new CreateScorFromArray(documents));
	}
}
